import React from "react";
import { PageHeader } from "../../../components";

export default function CHAIRMANSQUASH() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_CHAIRMAN_SQUASH.JPG"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">Mr. SESAN ASANI </h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                  Sesan Asani is the CEO, Conlog Logistics Services Ltd & Operations Director, Conair Cargo Services Ltd.

                    He holds MBA Degree in Southwales University and
                    BSc Economics in University of Ilorin.

                    He has a strong background in Customer Service, People and Process Management and a Corporate Strategist.

                    Sesan happily Married, blessed with kids and a lover of Squash. 
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
